import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { ReservationComponent } from './reservation.component';
import { ReservationDetailComponent } from './reservation-detail.component';
import { ReservationPopupComponent } from './reservation-dialog.component';
import { ReservationDeletePopupComponent } from './reservation-delete-dialog.component';
import { ReservationUnlinkPopupComponent } from './reservation-unlink-dialog.component';
import { ReservationPayPopupComponent } from './reservation-pay-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class ReservationResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'lesson.begining,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const reservationRoute: Routes = [
    {
        path: 'reservation',
        component: ReservationComponent,
        resolve: {
            'pagingParams': ReservationResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservation.home.title'
        }
    }, {
        path: 'reservation/:id',
        component: ReservationDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservation.home.title'
        }
    }
];

export const reservationPopupRoute: Routes = [
    {
        path: 'reservation-new',
        component: ReservationPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservation.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'reservation-new-for-student/:studentId',
        component: ReservationPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' ],
            pageTitle: 'jYoguiApp.reservation.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'reservation-new-for-lesson/:lessonId',
        component: ReservationPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' ],
            pageTitle: 'jYoguiApp.reservation.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'reservation/:id/edit',
        component: ReservationPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservation.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'reservation/:id/delete',
        component: ReservationDeletePopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.reservation.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'reservation/:id/unlink',
        component: ReservationUnlinkPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.reservation.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'reservation/:id/pay',
        component: ReservationPayPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.reservation.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation/reservation.route.ts